<template>
  <div class="impressum">
    <div class="heading-3-bold popup-title">Impressum</div>
    <div class="paragraph-1">
      <div class="subtitle">Verantwortlich für den Inhalt</div>
      Marco Quinter<br/>
      SWISS ENGINEERS UNITED AG<br/>
      Churerstrasse 54<br/>
      CH-8808 Pfäffikon SZ<br/>
      +41 58 521 19 00<br/>
      <a class="text-highlight"> info@seu.ch</a>
    </div>

    <div class="paragraph-1">
      <div class="subtitle">Konzeption und Text</div>
      Uta De Monte<br/>
      <a class="text-highlight" href=" www.kommunikation-demonte.ch" target="_blank">www.kommunikation-demonte.ch</a>
    </div>

    <div class="paragraph-1">
      <div class="subtitle">Design</div>
      Tale Mitreski
    </div>


    <div class="paragraph-1">
      <div class="subtitle">Fotos</div>
      Tale Mitreski & René Da Rold Pictures
    </div>

    <div class="paragraph-1">
      <div class="subtitle">Webdesign, Programmierung</div>
      Tale Mitreski & Kliment Lambevski
    </div>


  </div>
</template>

<script>
export default {
  name: 'Impressum',

}
</script>

<style lang="scss">
@import "Impressum.scss";
</style>
